import { TierDM } from "./tier_dm";

export class StarSummaryDM {
  constructor({
    total_stars = 0,
    total_stars_label = "",
    current_tier = {},
    next_tier = {},
    next_tier_rewards = [],
    star_categories = {},
    stars_to_next_tier = {},
    total_next_tier_rewards = {},
  }) {
    this.total_stars = total_stars;
    this.total_stars_label = total_stars_label;
    this.current_tier = current_tier;
    this.next_tier = next_tier;
    this.next_tier_rewards = next_tier_rewards;
    this.star_categories = star_categories;
    this.stars_to_next_tier = stars_to_next_tier;
    this.total_next_tier_rewards = total_next_tier_rewards;
  }

  static fromJson(json) {
    return new StarSummaryDM({
      total_stars: json["total_stars"],
      total_stars_label: json["total_stars_label"],
      current_tier: TierDM.fromJson(json["current_tier"]),
      next_tier: TierDM.fromJson(json["next_tier"]),
      next_tier_rewards: json["next_tier_rewards"],
      star_categories: json["star_categories"],
      stars_to_next_tier: json["stars_to_next_tier"],
      total_next_tier_rewards: json["total_next_tier_rewards"],
    });
  }
}
